import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BADGE_TYPES } from '../../constants';
import { BadgeModule, SpinnerModule, TooltipModule } from '@coreui/angular';

@Component({
  selector: 'smarsh-item-custom-badge',
  standalone: true,
  imports: [CommonModule, BadgeModule, TooltipModule, SpinnerModule],
  template: `<c-badge class="custom-badge" [color]="badgeType">
      {{ dataValue }}</c-badge
    >
    @if (showBlinker) {
      <c-spinner
        size="sm"
        class="spinner"
        color="warning"
        variant="grow"
        [cTooltip]="blinkerTooltip"></c-spinner>
    } `,

  styles: `
    .custom-badge {
      min-width: 50px;
    }
    .spinner {
      margin-left: 8px;
    }
  `
})
export class ItemCustomBadgeComponent implements ICellRendererAngularComp {
  dataValue: number | string;
  badgeType: BADGE_TYPES;
  showBlinker = false;
  blinkerTooltip = '';

  agInit(params: ICellRendererParams): void {
    this.dataValue = params.value;
    this.badgeType = params['badgeType'] || '';
    this.showBlinker = params['showBlinker'] || false;
    this.blinkerTooltip = params['blinkerTooltip'] || '';
  }

  refresh(params: ICellRendererParams): boolean {
    this.dataValue = params.value;
    return true;
  }

  getBadgeType() {
    switch (this.badgeType) {
      case BADGE_TYPES.BADGE_SUCCESS:
        return 'bg-success';
      case BADGE_TYPES.BADGE_DANGER:
        return 'bg-danger';
      case BADGE_TYPES.BADGE_WARNING:
        return 'bg-warning';
    }
  }
}
